import USER_TYPES from '../data/user-types';

export const moduleDefaultProps = { name: '' };

export const examTypeDefaultProps = { name: '' };

export const patientDefaultProps = {
  name: '',
  type: '',
  inscription: '',
  sex: '',
  age: '',
  weight: 0,
  height: 0,
  bmi: 0,
};

export const doctorDefaultProps = {
  institutions: [],
  files: [],
  cpf: '',
  type: USER_TYPES.DOC.key,
  phone: null,
  inscription: null,
  image: null,
  access_to_exams: false,
  access_to_report: false,
  access_to_patient_data: false,
  access_to_images: false,
  accepts_usage_terms: false,
  accepts_privacy_policy: false,
};

export const technicianDefaultProps = {
  name: '',
  type: '',
  inscription: '',
};

export const companyDefaultProps = {
  cnpj: '',
  name: '',
};

export const examDefaultProps = {
  comments: '',
  company: companyDefaultProps,
  date_created: '',
  date_requested: '',
  doctor: doctorDefaultProps,
  image: '',
  modality: '',
  module: moduleDefaultProps,
  patient: patientDefaultProps,
  registry: '',
  status: '',
  technician: technicianDefaultProps,
  type: examTypeDefaultProps,
};

export const singleGlyphDefaultProps = {
  high: 0,
  low: 0,
  normal: 0,
  percent: 0,
};

export const glyphDefaultProps = {
  ll: singleGlyphDefaultProps,
  lu: singleGlyphDefaultProps,
  rl: singleGlyphDefaultProps,
  rm: singleGlyphDefaultProps,
  ru: singleGlyphDefaultProps,
};

export const histogramDefaultProps = {
  high: [],
  low: [],
  max: 0,
  min: 0,
  normal: [],
};

export const imageDefaultProps = {
  image: '',
  report: 0,
};

export const attenuationLowNormalOrHighDefaultProps = {
  LL: 0,
  LU: 0,
  RL: 0,
  RM: 0,
  RU: 0,
  classes: [],
  total: 0,
};

export const reportAttenuationDefaultProps = {
  high: attenuationLowNormalOrHighDefaultProps,
  low: attenuationLowNormalOrHighDefaultProps,
  normal: attenuationLowNormalOrHighDefaultProps,
};

export const reportDefaultProps = {
  attenuation: reportAttenuationDefaultProps,
  consolidation_g: 0,
  consolidation_ml: 0,
  cp_lo_g: 0,
  cp_lo_ml: 0,
  exam: examDefaultProps,
  ggo_g: 0,
  ggo_ml: 0,
  glyph: glyphDefaultProps,
  glyph_processed: glyphDefaultProps,
  histogram: histogramDefaultProps,
  histogram_processed: histogramDefaultProps,
  images: [],
  normal: 0,
  pulmonary_involvement_extent_ptlv: 0,
  pulmonary_involvement_extent_tlv: 0,
  pulmonary_involvement_severity_ptlw: 0,
  pulmonary_involvement_severity_tlw: 0,
  tlv: 0,
  tlw: 0,
  well_aerated: 0,
};

export const justificationDefaultProps = {
  name: '',
  description: '',
};

export const dicomImagesDefaultProps = {
  jpeg: '',
};

export const examSerieDefaultProps = {
  dicomImages: [],
  imagesCount: 0,
  seriesDate: '',
  seriesDescription: '',
  seriesInstanceUID: '',
  uploaded: false,
};
